import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { useCommon } from 'src/AppState/Common';
import { useAppStateContext } from 'src/AppState/AppState';
import { DateTime } from 'src_common/utils/time/time';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

type FreeBetsHistoryPropsType = {
    currency: CurrencyType;
    customerId: number;
};

const defaultDateFormat = 'DD/MM/YY';

export const FreeBetHistoryBonusEngine = observer(
    'FreeBetHistoryBonusEngine',
    ({ customerId, currency }: FreeBetsHistoryPropsType) => {
        const common = useCommon();
        const { bankingTabState } = useAppStateContext();
        const state = bankingTabState.get(customerId);
        const { precision } = ConfigState.get(common);
        const freebetsHistory = state.freebetsListBonusEngine.get();
        const historyIsEmpty = freebetsHistory.type === 'ready' && freebetsHistory.value.length === 0;

        return (
            <div className='freebets-history'>
                <table key='free-bets-history-table'>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Promotion / Source</th>
                            <th className='align-right'>Total Value</th>
                            <th className='align-right'>Status</th>
                            <th className='align-right'>Current Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historyIsEmpty ? (
                            <div
                                className='info-message'
                                key='info'
                            >
                                No free bets history for this period of time
                            </div>
                        ) : null}

                        {freebetsHistory.type === 'ready'
                            ? freebetsHistory.value.reverse().map((bonusItem, index) => {
                                  const expiryDate = bonusItem.expiryAt;
                                  const date = bonusItem.createdAt ?? undefined;
                                  const promotion =
                                      bonusItem.rewardName === null
                                          ? bonusItem.bonusSource
                                          : `${bonusItem.rewardName} - ${bonusItem.bonusSource}`;
                                  const amount = bonusItem.totalAmount;
                                  const currentBalance = bonusItem.currentAmount;
                                  const type = bonusItem.status;

                                  return (
                                      <tr key={`${bonusItem.bonusId}${expiryDate}${index}`}>
                                          <td data-test='free-bet-history-date'>
                                              {DateTime.from(date)?.format(defaultDateFormat)}
                                          </td>
                                          <td data-test='free-bet-history-promotion/source'>
                                              <span key='promotion-name'> {promotion}</span>
                                              <span
                                                  key='expiry-date'
                                                  className='small-text'
                                              >
                                                  Expires: {DateTime.from(expiryDate)?.format(defaultDateFormat)}
                                              </span>
                                          </td>
                                          <td
                                              className='align-right'
                                              data-test='free-bet-history-amount'
                                          >
                                              {amount !== undefined && amount !== null
                                                  ? precision.newFromOld(amount).format(currency)
                                                  : '-'}
                                          </td>

                                          <td
                                              className='align-right text-capitalize'
                                              data-test='free-bet-history-status'
                                          >
                                              <span key='type'>{type}</span>
                                          </td>
                                          <td
                                              className='align-right'
                                              data-test='free-bet-history-balance'
                                          >
                                              {currentBalance === null
                                                  ? '-'
                                                  : precision.newFromOld(currentBalance ?? 0).format(currency)}
                                          </td>
                                      </tr>
                                  );
                              })
                            : null}
                    </tbody>
                </table>
                {freebetsHistory.type === 'loading' ? (
                    <div
                        className='spinner spinner--inline'
                        key='spinner'
                    ></div>
                ) : null}
            </div>
        );
    }
);
